import React from 'react'
import { observer } from 'mobx-react'
import OwnedGeopolygon from './OwnedGeopolygon'
import SharedGeopolygon from './SharedGeopolygon'

const GeopolygonPane = ({ geopolygon, group }) => {
  const isShared = group && group.share_type && group.share_type !== 'none'
  const canManage = isShared
    ? !!(geopolygon && geopolygon.is_owner)
    : !!(group && group.is_owner)
  return (
    canManage
      ? <OwnedGeopolygon geopolygon={geopolygon} group={group} />
      : <SharedGeopolygon geopolygon={geopolygon} group={group} />
  )
}

export default observer(GeopolygonPane)
